export default "__VITE_ASSET__CW3hQPg1__"